import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";
import AngSelect from "Common/Angular/AngSelect";

export const CityNumberSelector = (props) => {
  const { label, param, AccountDetailData, taskConfig, setValue } = props;
  return (
    <div style={{ padding: "7px" }}>
      <div>{label}</div>
      <div style={getStyleJSON("padding-top: 10px;")}>
        <AngSelect
          ng-model={taskConfig[param]}
          options={AccountDetailData.heroes
            ? AccountDetailData.heroes.map((city) => {
              return {
                label: city.cityname,
                value: city.cityno,
              };
            })
            : []}
          onChange={({ value }) => {
            setValue({ target: { value } }, param);
          }} />
      </div>
    </div>
  );
};
